var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"uc-layout-two-column"},[_c('div',{staticClass:"left-column"},[_vm._t("left-column")],2),_vm._v(" "),_c('div',{staticClass:"right-column"},[_vm._t("right-column")],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }